/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.geofences

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import features.geofences.internal.GeofencesUseCase
import features.geofences.internal.GeofencesUseCase.Params
import features.geofences.models.GeofencesModel


typealias GeofencesState = CFlow<GeofencesUseCaseResult?>

typealias GeofencesUseCaseResult = Result<GeofencesModel>

fun GeofencesUseCaseResult.serializeGeofencesApiResult(): SerializedResult<String> {
    return this.toJsonResult<GeofencesModel>()
}

/**
 * Serializes [GeofencesState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun GeofencesState.serializeGeofencesState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<GeofencesModel>()
    }.asCFlow()
}

/**
 * Get the list of geofences of a business [Api] class
 */
class GeofencesApi : Api() {

    val geofencesState: GeofencesState
        get() = _geofencesState.asCFlow()

    companion object {
        private val _geofencesState: MutableStateFlow<GeofencesUseCaseResult> = MutableStateFlow(Idle())
    }

    private val geofencesUseCase = GeofencesUseCase()

    /**
     * Get the list of geofences of a business
     */
    suspend fun getBusinessGeofences(
        overrideHeaders: Map<String, String>? = null,
        pageNumber: Int,
        perPage: Int
    ): Result<GeofencesModel> {
        /* set state to Loading as soon as function is called */
        _geofencesState.value = Loading()
        val result = this.geofencesUseCase(
            Params(
                overrideHeaders = overrideHeaders,
                pageNumber = pageNumber,
                perPage = perPage
            )
        ) { result ->
            _geofencesState.value = result
            return@geofencesUseCase result
        }
        return result
    }

}
